import { BaseEmailCapture, BaseEmailCaptureProps } from './BaseEmailCapture'

export function LowCoverageEmailCapture({
  onSubmit,
  isSuccessful,
  setIsSuccessful,
  processing,
}: BaseEmailCaptureProps) {
  return (
    <BaseEmailCapture
      onSubmit={onSubmit}
      isSuccessful={isSuccessful}
      setIsSuccessful={setIsSuccessful}
      processing={processing}
      title="Not seeing the rates you're looking for?"
      subtitle="Our available offers fluctuate depending on when you're here. Get notified by signing up for our rate alerts."
    />
  )
}
